import { createApp } from 'vue'
import StafetPayment from './StafetPayment'

const el = '.kb-component--stafet-flow-payment'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetPaymentDOM) => {
            const component = createApp(StafetPayment).use(Store)
            component.mount(StafetPaymentDOM)
        })
    }
}
